import React from "react";
import { Form, Formik, FormikProps } from "formik";
import TextArea from "../../../designComponents/TextArea";
import Typography from "../../../designComponents/Typography";
import Button from "../../../designComponents/Button";
import { AddPropertyProps } from ".";
import { PropertyAddressType } from "./types";

const Description: React.FC<AddPropertyProps> = ({
  initialValues,
  onUpdate,
  gotoPrevious,
  errorMessage,
  loading,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <Typography style={{ marginBottom: "10px" }} size="h3">
        Step 5: Description
      </Typography>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          onUpdate(values);
        }}
      >
        {(formikProps: FormikProps<PropertyAddressType>) => (
          <Form>
            <Typography style={{ marginBottom: "10px" }} size="h4">
              Description
            </Typography>
            <TextArea
              name="description"
              value={formikProps.values.description || ""}
              onChange={(e) =>
                formikProps.setFieldValue("description", e.target.value)
              }
              placeholder="Add Description"
              rows={15}
              maxLength={10000}
              style={{ marginBottom: "20px" }}
            />
            {errorMessage && (
              <Typography style={{ color: "red" }}>{errorMessage}</Typography>
            )}
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Button
                type="button"
                radius="normal"
                onClick={gotoPrevious}
                isDisabled={loading}
              >
                Previous
              </Button>
              <Button type="submit" radius="normal" isLoading={loading}>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Description;
